import {
    useEffect,
    useState
} from 'react';
import { useSelector } from 'react-redux';

import { dbGettr } from '../selectors/utils';

export const useRemoteConfigValue = (value, defaultValue) => {
    const [ result,
        setResult ] = useState(null);
    const db = useSelector(dbGettr(value));

    useEffect(() => {
        if (db === undefined || db === null) {
            setResult(defaultValue);
            return;
        }
        setResult(db);
    }, [ db,
        defaultValue ]);

    return result;
};
